module.exports = __webpack_public_path__ + "static/img/mbg.a288c98.png";


//////////////////
// WEBPACK FOOTER
// ./static/mbg.png
// module id = 1ain
// module chunks = 24